export default {
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-export_csv_file-packing_slips_info_text',
    defaultMessage:
      'Heads up: You can only export 30 days of packing slips at a time.',
  },
} as const
